// extracted by mini-css-extract-plugin
export var root = "Banner-module--root--0Lf0Y";
export var content = "Banner-module--content--B-TYt";
export var subtitle = "Banner-module--subtitle--SN6e3";
export var hideSubtitleOnMobile = "Banner-module--hideSubtitleOnMobile--vie8n";